module.exports = "/build/web/images/partners/espn.b90fc40664869d311d071ef20337ee2b.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/espn.png
// module id = 128
// module chunks = 24